export enum PaginationTypeEnum {
  ACTIVITIES = 'activities',
  TIMESLOTS = 'timeslots',
  ADVICES = 'advices',
}
